function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "no_computer"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m19 3h-10c-.553 0-1 .447-1 1s.447 1 1 1h10c.552 0 1 .448 1 1v8c0 .267-.103.514-.287.693-.396.386-.404 1.019-.02 1.414.196.201.456.303.717.303.252 0 .503-.095.697-.283.577-.561.893-1.315.893-2.127v-8c0-1.654-1.346-3-3-3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.707 2.293c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l.395.395c-.434.526-.688 1.192-.688 1.898v8c0 1.654 1.346 3 3 3h4v2h-1c-.553 0-1 .447-1 1s.447 1 1 1h8c.553 0 1-.447 1-1s-.447-1-1-1h-1v-2h.586l4.707 4.707c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414zm.293 11.707v-8c0-.165.049-.32.124-.462l9.462 9.462h-8.586c-.552 0-1-.448-1-1zm9 5h-2v-2h2z"
})));

var Svg071Computer = function Svg071Computer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg071Computer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/071-computer.d6787fa2.svg";
export { ForwardRef as ReactComponent };